import { apiCall } from "../../../services/api-service.js";

const get = (endpoint, params) => apiCall("get", endpoint, null, { params });
const post = (endpoint, body) => apiCall("post", endpoint, body);
const put = (endpoint, body) => apiCall("put", endpoint, body);
const del = (endpoint, data = null) => apiCall("delete", endpoint, data);

export const getProjectStageListApi = async (params) => {
  try {
    return await get("project_stage", params);
  } catch (err) {
    console.error("Error fetching category:", err);
  }
};


export const submitProjectStageApi = async (body) => {
  try {
    return await post("project_stage", body);
  } catch (err) {
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};


export const updateProjectStageListApi = async (id, body) => {
  try {
    return await put(`project_stage/${id}`, body);
  } catch (err) {
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const bulkDeleteProjectStageApi = async (payload) => {
  try {
    const data = Array.isArray(payload) ? { id: payload } : payload;
    return await del("project_stage/bulk_delete", data);
  } catch (err) {
    console.error("Error fetching category:", err);
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const deleteProjectStageListApi = async (id) => {
  try {
    return await del(`project_stage/delete/${id}`);
  } catch (err) {
    console.error("Error fetching category:", err);
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};
export const getProjectStageByIdApi = async (id) => {
  try {
    return await get(`project_stage/edit/${id}`);
  } catch (err) {
    console.error("Error fetching category:", err);
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};